
import {
  Menu as RaMenu,
  useResourceDefinitions,
  useTranslate
} from 'react-admin'
import { restrictToDriverType } from '../../data-model'
import ListIcon from '@mui/icons-material/List'
import { useSettings } from '../../hooks'

const sx = {
  textTransform: 'capitalize',
  '& .RaMenuItemLink-icon': {
    minWidth: 0,
    marginRight: 1,
  }
}

const Menu = () => {
  const resources = useResourceDefinitions()
  const translate = useTranslate()
  const { driverType } = useSettings()

  return (
    <RaMenu
    >
      <RaMenu.DashboardItem sx={sx} />
      {
        Object.keys(resources).map(key => {
          if (!resources[key].hasList) return null
          const requiredDriverType = restrictToDriverType[key]
          if (requiredDriverType && driverType !== requiredDriverType) return null

          return (
            <RaMenu.Item
              key={key}
              to={`/${resources[key].name}`}
              primaryText={translate(`resources.${resources[key].name}.name`, { smart_count: 2 })}
              leftIcon={resources[key].icon || <ListIcon />}
              sx={sx}
            />
          )
        })
      }
    </RaMenu>
  )
}

export default Menu
